var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.544,
    height: 64.871,
    viewBox: "0 0 40.544 64.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_3_",
    "data-name": "microphone (3)",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11227",
    "data-name": "Path 11227",
    d: "M17.163,40.544h0A11.946,11.946,0,0,1,5,28.381V12.163A12.2,12.2,0,0,1,17.163,0h0A12.2,12.2,0,0,1,29.327,12.163V28.381A12.471,12.471,0,0,1,17.163,40.544Z",
    transform: "translate(6.109)",
    fill: "#1a5560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11228",
    "data-name": "Path 11228",
    d: "M39.49,5V15.136c0,7.7-7.3,14.191-15.407,14.191H22.461c-8.109,0-15.407-6.487-15.407-14.191V5A3.831,3.831,0,0,0,3,9.054v6.082c0,8.92,7.3,16.623,16.218,17.84V41.49C7.054,41.49,9.082,49.6,9.082,49.6H37.463S39.49,41.49,27.327,41.49V32.976c8.92-1.622,16.218-8.92,16.218-17.84V9.054A3.831,3.831,0,0,0,39.49,5Z",
    transform: "translate(0 15.272)",
    fill: "#1a5560"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/microphone_icon.c14778ae.svg";
export { ForwardRef as ReactComponent };